<template>
    <div class="monitor-item">
        <component :is="component.name" v-bind="component.options" :params="params" :payload="data" @update="refresh" @init="refresh" />
        <div v-if="isLoading" class="loader">
            <loader size="60" />
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data() {
            console.log('monitor initialized');
            return {
                isLoading: false,
                data: undefined,
                error: ''
            };
        },
        props: {
            id: Number,
            params: Object,
            alt_name: {
                type: String,
                default: ''
            },
            component: Object,
            filters: Array
        },
        methods: {
            refresh(params = {}) {
                this.update(params)
                    .then(this.load.bind(this));
            },
            load() {
                return this.request(() => {
                    return axios.get(this.route('monitors.data', {settings: this.id})).then(response => {
                        this.data = response.data;
                    });
                })
            },
            update(params) {
                return this.request(() => {
                    return axios.put(this.route('monitors.update', this.id), {params});
                })
            },
            request(requestFunc) {
                this.error = '';
                this.isLoading = true;

                return requestFunc()
                    .then(() => {
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        this.error = error.response.data.message;
                        this.isLoading = false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .monitor-item {
        position: relative;

        .loader {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, .75);
        }
    }
</style>
